import Login from "../../components/layouts/login/login-page/Login"
import ForgotPassword from "../../components/layouts/login/forgot-password/ForgotPassword"
import ResetPassword from "../../components/layouts/login/reset-password/ResetPassword"
import Account from "../../components/layouts/account/Account"
import { RouteProps } from "../../types"
import Catalog from "../../components/layouts/catalog/Catalog"
import ReleaseDetail from "../../components/layouts/catalog/ReleaseDetail"
import Analysis from "../../components/layouts/analysis/Analysis"
import AdminUserAsset from "../../components/layouts/admin/AdminUserAsset"
import {
  ADMIN_PERMISSIONS,
  adminRoleList,
  allRoleList,
  DEFAULT_ROUTE,
  regularRoleList,
  USER_ROLE
} from "../../constants"
import ReportsApproval from "../../components/layouts/admin/reports-approval/ReportsApproval"
import InvitationAccept from "../../components/layouts/public/invitation/InvitationAccept"
import AdminCatalog from "../../components/layouts/admin/admin-catalog/AdminCatalog"
import SchedulerLog from "../../components/layouts/admin/scheduler-logs/SchedulerLog"
import React from "react"
import AssetRegistry from "../../components/layouts/catalog/asset-registry/AssetRegistry"
import ReleaseRegistry from "../../components/layouts/catalog/release-registry/ReleaseRegistry"
import AffiliatePage from "../../components/layouts/affiliate/AffiliatePage"
import ReleaseSmartLinkPage from "../../components/layouts/release-smart-link/ReleaseSmartLinkPage"
import ReleaseSmartLinkPublicPage from "../../components/layouts/release-smart-link/public/ReleaseSmartLinkPublicPage"
import ArtistSmartLinkPage from "../../components/layouts/artist-smart-link/ArtistSmartLinkPage"
import ArtistSmartLinkPublicPage from "../../components/layouts/artist-smart-link/public/ArtistSmartLinkPublicPage"
import AdminTerritoryDsp from "../../components/layouts/admin/territory-dsp/AdminTerritoryDsp"
import Registrations from "../../components/layouts/admin/registrations/Registrations"
import Overview from "../../components/layouts/overview/Overview"
import NewReleaseAction from "../../components/layouts/catalog/asset-registry/new-release-action/NewReleaseAction"
import StartYourJourney from "../../components/layouts/start-your-journey/StartYourJourney"
import NotificationsPage from "../../components/layouts/notifications/NotificationsPage"
import Playlists from "../../components/layouts/playlists/Playlists"
import Trends from "../../components/layouts/trends/Trends"
import Marketing from "../../components/layouts/marketing/Marketing"
import ReleaseSubmission from "../../components/layouts/release-submission/ReleaseSubmission"
import CreatePassword from "../../components/layouts/login/create-password/CreatePassword"
import AdminUserTakedown from "../../components/layouts/admin/user-takedown/AdminUserTakedown"
import NewReleaseCodes from "../../components/layouts/admin/new-release-codes/NewReleaseCodes"
import AdminState51Delivery from "../../components/layouts/admin/state-51-delivery/AdminState51Delivery"
import AdminFinanceReporting from "../../components/layouts/admin/finance-reporting/FinanceReporting"
import AdminActions from "../../components/layouts/admin/actions/AdminActions"
import AdminAnnouncements from "../../components/layouts/admin/announcements/AdminAnnouncements"
import Royalties from "../../components/layouts/royalties/Royalties"
import Reports from "../../components/layouts/royalties/reports/Reports"
import AnalysisNew from "../../components/layouts/analysis-new/Analysis"

export const ROUTES: RouteProps[] = [
  {
    path: "/",
    element: <div />,
    redirect: DEFAULT_ROUTE,
    private: true,
    permittedRoles: regularRoleList
  },
  {
    path: "/login",
    element: <Login />,
    private: false
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
    private: false
  },
  {
    path: "/forgot-password/:email",
    element: <ResetPassword />,
    private: false
  },
  {
    path: "/create-password/:email",
    element: <CreatePassword />,
    private: false
  },
  {
    path: "/overview",
    element: <Overview />,
    private: true,
    permittedRoles: allRoleList
  },
  /*{
    path: "/analytics",
    element: <Analysis />,
    private: true,
    permittedRoles: allRoleList
  },*/
  {
    path: "/insights",
    element: <AnalysisNew />,
    private: true,
    permittedRoles: allRoleList
  },
  /*{
    path: "/daily-trends",
    element: <Trends isAdmin={false} />,
    private: true,
    permittedRoles: regularRoleList
  },*/
  {
    path: "/reports",
    element: <Reports isAdmin={false} />,
    private: true,
    permittedRoles: regularRoleList
  },
  {
    path: "/royalties",
    element: <Royalties isAdmin={false} />,
    private: true,
    permittedRoles: regularRoleList
  },
  {
    path: "/account/profile",
    element: <Account selected={"profile"} />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/account/language",
    element: <Account selected={"language"} />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/account/payment-methods",
    element: <Account selected={"paymentMethods"} />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/account/user-contract",
    element: <Account selected={"userContract"} />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/account/copyright-and-production",
    element: <Account selected={"copyrightAndProduction"} />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/account/label-beatport-logo",
    element: <Account selected={"labelBeatportLogo"} />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/account/social-media-links",
    element: <Account selected={"socialMediaLink"} />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/account/events",
    element: <Account selected={"events"} />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/account/contracts",
    element: <Account selected={"contracts"} />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/catalog",
    element: <Catalog />,
    private: true,
    permittedRoles: regularRoleList
  },
  {
    path: "/marketing",
    element: <Marketing />,
    private: true,
    permittedRoles: regularRoleList
  },
  {
    path: "/catalog/new-release",
    element: <NewReleaseAction />,
    private: true,
    permittedRoles: regularRoleList
  },
  {
    path: "/catalog/:releaseId",
    element: <ReleaseDetail isAdmin={false} />,
    private: true,
    permittedRoles: regularRoleList
  },
  {
    path: "/catalog/asset-registry/:releaseId",
    element: <AssetRegistry />,
    private: true,
    permittedRoles: regularRoleList
  },
  {
    path: "/catalog/release-registry/:releaseId",
    element: <ReleaseRegistry />,
    private: true,
    permittedRoles: regularRoleList
  },
  {
    path: "/catalog/release-submission",
    element: <ReleaseSubmission isAdmin={false} />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/admin/user-asset",
    element: <AdminUserAsset />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.USER_ASSET_READ, ADMIN_PERMISSIONS.USER_ASSET_LOGS],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/catalog",
    element: <AdminCatalog />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.ASSET_REGISTRY_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/catalog/:releaseId",
    element: <ReleaseDetail isAdmin={true} />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.ASSET_REGISTRY_WRITE],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/release-submission",
    element: <ReleaseSubmission isAdmin={true} />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.RELEASE_SUBMISSION_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/royalty-reports",
    element: <Reports isAdmin={true} />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.ROYALTY_REPORTS_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/royalties",
    element: <Royalties isAdmin={true} />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.ROYALTY_REPORTS_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/user-takedown",
    element: <AdminUserTakedown />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.USER_TAKEDOWN_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/state-51-deliveries",
    element: <AdminState51Delivery />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.STATE_51_DELIVERIES_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/reports-approval",
    element: <ReportsApproval />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.REPORTS_APPROVAL_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/scheduler-logs",
    element: <SchedulerLog />,
    private: true,
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/new-release-codes",
    element: <NewReleaseCodes />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.NEW_RELEASE_CODES_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/actions",
    element: <AdminActions />,
    private: true,
    permittedAdminPermissons: [
      ADMIN_PERMISSIONS.ACTIONS_MISSING_SHARE_HOLDER,
      ADMIN_PERMISSIONS.ACTIONS_ROYALTY_SUMMARY_DUPLICATE
    ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/finance-reporting",
    element: <AdminFinanceReporting />,
    private: true,
    permittedAdminPermissons: [
      ADMIN_PERMISSIONS.FINANCE_REPORTING_PL,
      ADMIN_PERMISSIONS.FINANCE_REPORTING_USER_ADVANCE
    ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/playlists",
    element: <Playlists isAdmin={true} />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.PLAYLIST_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/trends",
    element: <Trends isAdmin={true} />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.DAILY_TRENDS_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/territory-dsp",
    element: <AdminTerritoryDsp />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.TERRITORY_DSP_LIST_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/registrations",
    element: <Registrations />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.REGISTRATIONS_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/admin/announcements",
    element: <AdminAnnouncements />,
    private: true,
    permittedAdminPermissons: [ADMIN_PERMISSIONS.USER_ASSET_READ],
    permittedRoles: adminRoleList
  },
  {
    path: "/invitation",
    element: <InvitationAccept />,
    private: false,
    overrideDefaultRoute: true
  },
  {
    path: "/artist/:smartLink",
    element: <ArtistSmartLinkPublicPage />,
    private: false,
    overrideDefaultRoute: true
  },
  {
    path: "/artist-space/",
    element: <ArtistSmartLinkPage />,
    private: true,
    permittedRoles: regularRoleList
  },
  {
    path: "/smart-link/:smartLink",
    element: <ReleaseSmartLinkPublicPage />,
    private: false,
    overrideDefaultRoute: true
  },
  {
    path: "/catalog/smart-link/:releaseId",
    element: <ReleaseSmartLinkPage />,
    private: true,
    permittedRoles: regularRoleList
  },
  {
    path: "/affiliate",
    element: <AffiliatePage />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/start-your-journey",
    element: <StartYourJourney />,
    private: false,
    permittedRoles: allRoleList
  },
  {
    path: "/notifications",
    element: <NotificationsPage />,
    private: true,
    permittedRoles: allRoleList
  },
  {
    path: "/playlists",
    element: <Playlists isAdmin={false} />,
    private: true,
    permittedRoles: regularRoleList
  }
]
